{
  "appName": "Simple Forms Patterns",
  "entryFile": "./app-entry.jsx",
  "entryName": "mock-simple-forms-patterns",
  "rootUrl": "/mock-simple-forms-patterns",
  "productId": "81df904b-0aec-4a1f-9141-cbaa9acee0ed"
}
